export default __webpack_public_path__ + "static/media/truck-04.b09e0510.jpg";